import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const isActive = (path: string) => location.pathname === path;

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
  };

  return (
    <>
      <nav
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
          isScrolled ? 'bg-white shadow-md' : 'bg-transparent'
        }`}
      >
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="flex items-center justify-between h-20">
            <Link to="/" className="flex items-center space-x-3 bg-white rounded-full px-4 py-2">
              <img 
                src="https://public.readdy.ai/ai/img_res/e5e5ebca-6c31-4d6a-aa45-8dc4b1082cf2.png" 
                alt="Logo" 
                className="h-20 w-auto"
              />
            </Link>

            <div className="hidden md:flex items-center space-x-8">
              <Link
                to="/"
                className={`text-sm font-medium transition-colors hover:text-teal-600 ${
                  isActive('/') ? 'text-teal-600' : 'text-gray-700'
                }`}
              >
                Ana Sayfa
              </Link>
              <Link
                to="/hakkimda"
                className={`text-sm font-medium transition-colors hover:text-teal-600 ${
                  isActive('/hakkimda') ? 'text-teal-600' : 'text-gray-700'
                }`}
              >
                Hakkımda
              </Link>
              <Link
                to="/hizmetler"
                className={`text-sm font-medium transition-colors hover:text-teal-600 ${
                  isActive('/hizmetler') ? 'text-teal-600' : 'text-gray-700'
                }`}
              >
                Hizmetler
              </Link>
              <Link
                to="/makaleler"
                className={`text-sm font-medium transition-colors hover:text-teal-600 ${
                  isActive('/makaleler') ? 'text-teal-600' : 'text-gray-700'
                }`}
              >
                Makaleler
              </Link>
              <Link
                to="/iletisim"
                className={`text-sm font-medium transition-colors hover:text-teal-600 ${
                  isActive('/iletisim') ? 'text-teal-600' : 'text-gray-700'
                }`}
              >
                İletişim
              </Link>
            </div>

            <Link
              to="/iletisim"
              className="hidden md:inline-flex items-center px-6 py-2.5 bg-teal-500 text-white text-sm font-medium rounded-full hover:bg-teal-600 transition-colors cursor-pointer whitespace-nowrap"
            >
              Randevu Al
              <i className="ri-arrow-right-up-line ml-2"></i>
            </Link>

            <button 
              onClick={toggleMobileMenu}
              className="md:hidden text-gray-700 cursor-pointer"
              aria-label="Menü"
            >
              <i className={`text-2xl ${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
            </button>
          </div>

          {/* Mobile Menu */}
          {isMobileMenuOpen && (
            <div className="md:hidden bg-white border-t border-gray-100 py-4">
              <div className="flex flex-col space-y-4">
                <Link
                  to="/"
                  onClick={closeMobileMenu}
                  className={`text-sm font-medium transition-colors hover:text-teal-600 px-4 py-2 ${
                    isActive('/') ? 'text-teal-600 bg-teal-50' : 'text-gray-700'
                  }`}
                >
                  Ana Sayfa
                </Link>
                <Link
                  to="/hakkimda"
                  onClick={closeMobileMenu}
                  className={`text-sm font-medium transition-colors hover:text-teal-600 px-4 py-2 ${
                    isActive('/hakkimda') ? 'text-teal-600 bg-teal-50' : 'text-gray-700'
                  }`}
                >
                  Hakkımda
                </Link>
                <Link
                  to="/hizmetler"
                  onClick={closeMobileMenu}
                  className={`text-sm font-medium transition-colors hover:text-teal-600 px-4 py-2 ${
                    isActive('/hizmetler') ? 'text-teal-600 bg-teal-50' : 'text-gray-700'
                  }`}
                >
                  Hizmetler
                </Link>
                <Link
                  to="/makaleler"
                  onClick={closeMobileMenu}
                  className={`text-sm font-medium transition-colors hover:text-teal-600 px-4 py-2 ${
                    isActive('/makaleler') ? 'text-teal-600 bg-teal-50' : 'text-gray-700'
                  }`}
                >
                  Makaleler
                </Link>
                <Link
                  to="/iletisim"
                  onClick={closeMobileMenu}
                  className={`text-sm font-medium transition-colors hover:text-teal-600 px-4 py-2 ${
                    isActive('/iletisim') ? 'text-teal-600 bg-teal-50' : 'text-gray-700'
                  }`}
                >
                  İletişim
                </Link>
                <Link
                  to="/iletisim"
                  onClick={closeMobileMenu}
                  className="mx-4 inline-flex items-center justify-center px-6 py-2.5 bg-teal-500 text-white text-sm font-medium rounded-full hover:bg-teal-600 transition-colors cursor-pointer whitespace-nowrap"
                >
                  Randevu Al
                  <i className="ri-arrow-right-up-line ml-2"></i>
                </Link>
              </div>
            </div>
          )}
        </div>
      </nav>
    </>
  );
}
